import React, { Component } from 'react';
import { Layout, Button, message, Spin } from 'antd';
import * as jwt_decode from 'jwt-decode';
import { withRouter } from 'react-router-dom';
import Service from './Service';

import Breadcrumb from '../../components/Breadcrumb';
import logoIcon from '../../images/logo-reduzida.png';
import './styles.css';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setClientFilial, setClientInvite } from '../../redux/actions';

const { Content } = Layout;

// Reconstruida 2026-08-12 - a versao antiga so lia inviteState[0] (nunca
// mostrava de qual empresa era o convite nem lidava com mais de um), e "Nao"
// mandava de volta pro /login, que mostrava a mesma tela de novo - um convite
// pendente sequestrava o login, sem jeito de entrar no sistema sem aceitar.
// Agora busca os convites direto (GET Convite), lista todos, e tem uma saida
// "Agora nao" que segue o fluxo normal.
class Invitation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      // true entre "nao sobrou convite" e a navegacao de fato acontecer
      // (irParaProximaTela e assincrono - faz uma chamada de rede antes de
      // navegar) - sem isso, a tela chegava a mostrar "0 convites
      // pendentes" por um instante antes de sair (achado pelo usuario,
      // 2026-08-12).
      redirecionando: false,
      processando: {},
      convites: [],
    };
    this.service = new Service();
  }

  componentDidMount() {
    if (!this.service.isLogged()) {
      this.props.history.push('/login');
      return;
    }

    const token = this.props.userData.object.token;
    const decodeToken = jwt_decode(token);
    this.setState({
      role: decodeToken.role,
      dataUser: decodeToken,
    });

    this.carregarConvites();
  }

  carregarConvites = async () => {
    this.setState({ loading: true });
    const result = await this.service.userInvitation();
    const convites = (result && result.object) || [];

    this.props.setClientInvite(convites);

    // Se nao sobrou nenhum convite (ex.: ja foi resolvido em outra aba), nao
    // deixa a tela vazia parada - segue o fluxo normal. redirecionando:true
    // junto no mesmo setState pra nunca chegar a renderizar "0 convites".
    const semConvites = convites.length === 0;
    this.setState({
      convites,
      loading: false,
      redirecionando: semConvites,
    });

    if (semConvites) {
      this.irParaProximaTela();
    }
  };

  irParaProximaTela = async () => {
    const resultado = await this.service.decidirDestinoPosLogin();

    if (resultado.destino) {
      this.props.setClientFilial(resultado.clientFilial);
      this.props.history.push(
        resultado.getFilial
          ? { pathname: resultado.destino, getFilial: resultado.getFilial }
          : resultado.destino
      );
    } else if (!this.props.userData.object.boolCompleteRegister) {
      this.props.history.push('/register');
    } else {
      this.props.history.push('/');
    }
  };

  responderConvite = async (convite, aceito) => {
    const idEmpresa = convite.idEmpresa;
    this.setState(state => ({
      processando: { ...state.processando, [idEmpresa]: true },
    }));

    const result = await this.service.acceptInvite({
      idEmpresa,
      aceito,
    });

    if (result && result.code === 200) {
      message.success(
        aceito
          ? `Convite da empresa ${convite.nomeEmpresa} aceito!`
          : `Convite da empresa ${convite.nomeEmpresa} recusado.`
      );

      const restantes = this.state.convites.filter(
        c => c.idEmpresa !== idEmpresa
      );
      this.props.setClientInvite(restantes);
      const semConvites = restantes.length === 0;
      this.setState({ convites: restantes, redirecionando: semConvites });

      if (semConvites) {
        this.irParaProximaTela();
      }
    } else {
      message.error(
        (result && result.mensage) || 'Não foi possível processar o convite.'
      );
      this.setState(state => ({
        processando: { ...state.processando, [idEmpresa]: false },
      }));
    }
  };

  render() {
    const { dataUser, convites, loading, redirecionando } = this.state;

    return (
      // minHeight 100vh (achado 2026-08-12): a classe global "content" limita
      // a altura a 86vh - sem isso, o Layout (com seu proprio background)
      // fica mais baixo que a tela, e o body/root aparece por baixo com uma
      // cor diferente, criando uma faixa visivel no topo.
      <Layout style={{ minHeight: '100vh' }}>
        <Breadcrumb pages={[{ title: '' }]} />
        <Content className="content">
          {/* position:fixed (nao absolute/relative ao Content, que fica
              deslocado pelo Breadcrumb acima) - assim a logo e o cartao
              ficam de verdade presos ao viewport, igual o resto do app.
              Posicao da logo replica a do Sidebar (components/Sidebar/
              styles.css: .logo { margin: 16px }), que fica fixo no canto
              superior esquerdo em toda tela pos-login. */}
          <img
            src={logoIcon}
            alt="Blue"
            style={{
              position: 'fixed',
              top: 16,
              left: 16,
              width: 56,
              height: 56,
              zIndex: 10,
            }}
          />
          <div
            className="invitation-overlay"
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
          <div
            style={{
              width: '100%',
              maxWidth: 600,
              background: '#fff',
              borderRadius: 24,
              boxShadow: '0 4px 24px rgba(0, 0, 0, 0.08)',
              padding: '48px 52px',
            }}
          >
            {loading || redirecionando ? (
              // Cobre tanto o carregamento inicial quanto o intervalo entre
              // aceitar/recusar o ultimo convite e a navegacao de fato
              // acontecer (irParaProximaTela e assincrono) - sem isso, a
              // tela chegava a mostrar "0 convites pendentes" por um
              // instante antes de sair (achado pelo usuario, 2026-08-12).
              <div style={{ textAlign: 'center', padding: '40px 0' }}>
                <Spin size="large" />
              </div>
            ) : (
              <>
            <h1 style={{ fontSize: 32, fontWeight: 800, marginBottom: 4 }}>
              Olá, {dataUser && dataUser.unique_name}.
            </h1>
            <p style={{ fontSize: 16, color: '#595959', marginBottom: 32 }}>
              Você tem {convites.length}{' '}
              {convites.length === 1
                ? 'convite pendente'
                : 'convites pendentes'}
              :
            </p>

              {convites.map(convite => (
                <div
                  key={convite.idEmpresa}
                  style={{ textAlign: 'center', marginBottom: 32 }}
                >
                  <h2 style={{ fontSize: 24, fontWeight: 800, marginBottom: 4 }}>
                    {convite.nomeEmpresa}
                  </h2>
                  <p style={{ color: '#595959', marginBottom: 24 }}>
                    {convite.acessoTotal ? (
                      'Acesso total.'
                    ) : (
                      <>
                        Acesso restrito à
                        {(convite.nomesFiliais || []).length > 1
                          ? 's unidades'
                          : ' unidade'}
                        : <strong>{(convite.nomesFiliais || []).join(', ')}</strong>.
                      </>
                    )}
                  </p>
                  <Button
                    style={{
                      marginRight: 16,
                      background: '#b7f0d1',
                      border: 'none',
                      color: '#1e7e4f',
                      borderRadius: 10,
                      fontWeight: 700,
                      textTransform: 'uppercase',
                      letterSpacing: 0.5,
                      height: 48,
                      padding: '0 32px',
                    }}
                    loading={!!this.state.processando[convite.idEmpresa]}
                    onClick={() => this.responderConvite(convite, true)}
                  >
                    Aceitar
                  </Button>
                  <Button
                    style={{
                      background: '#ffc9c9',
                      border: 'none',
                      color: '#c0392b',
                      borderRadius: 10,
                      fontWeight: 700,
                      textTransform: 'uppercase',
                      letterSpacing: 0.5,
                      height: 48,
                      padding: '0 32px',
                    }}
                    loading={!!this.state.processando[convite.idEmpresa]}
                    onClick={() => this.responderConvite(convite, false)}
                  >
                    Recusar
                  </Button>
                </div>
              ))}

            <div style={{ textAlign: 'center' }}>
              <Button
                style={{ borderRadius: 10, fontWeight: 600 }}
                onClick={() => this.irParaProximaTela()}
              >
                Decidir depois
              </Button>
            </div>
              </>
            )}
          </div>
          </div>
        </Content>
      </Layout>
    );
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ setClientFilial, setClientInvite }, dispatch);

const mapStateToProps = store => ({
  userData: store.userData.data,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Invitation));
